<mg-configurator-optiongroup [formControl]="componentFormControl" class="configuration-option-select-advanced-edition">
    <mg-configurator-optiongroup-option
        *ngFor="let option of options"
        [label]="option.label"
        [value]="option.id"
        [description]="
            { optionName: configurationOption.name, key: 'optionDescription', selectableOptionId: option.labelId }
                | optionTranslation
                | async
        "
    >
        <mg-ui-modal [keys]="[option.labelId, option.label]">
            <mat-icon class="configurator-icon-modal">info_outline</mat-icon>
        </mg-ui-modal>
    </mg-configurator-optiongroup-option>
</mg-configurator-optiongroup>
